// extracted by mini-css-extract-plugin
module.exports = {"Space":"Space--ajtF3","Icon":"Icon--2vtHL"};